import { useContext, createContext } from 'react';

export const CalculatorContext = createContext(null);

const useCalculatorContext = () => useContext(CalculatorContext);

export default useCalculatorContext;
